module.exports = __webpack_public_path__ + "img/live_storm_media_logo_edit.32686768.png";